import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useAppSelector } from '../../../hooks';
import { selectNexaReceivers } from '../../../reducers/nexaReceiversSlice';
import { ConfigNexaReceiverRow } from './ConfigNexaReceiverRow';
import { DialogNexaReceiverEdit } from './DialogNexaReceiverEdit';
export const ConfigNexaReceivers = (_props) => {
    const receiversMap = useAppSelector(selectNexaReceivers);
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [id, setId] = useState('new');
    const edit = (id) => { setId(id); setEditDialogVisible(true); };
    const newReceiver = () => { setId('new'); setEditDialogVisible(true); };
    const receivers = Object.values(receiversMap).sort((a, b) => a.title.localeCompare(b.title));
    const rows = [];
    if (receivers) {
        for (const t of receivers) {
            rows.push(_jsx(ConfigNexaReceiverRow, { id: t.id, editHandler: edit }, t.id));
        }
    }
    return (_jsxs("div", { className: "page-container", children: [_jsx("h2", { children: "Nexa-mottagare" }), _jsx(DialogNexaReceiverEdit, { isOpen: editDialogVisible, id: id, onClose: () => setEditDialogVisible(false) }, 'id'), _jsx("div", { className: "operations", children: _jsx("button", { className: "lw success", onClick: () => newReceiver(), children: "\u00A0L\u00E4gg till mottagare...\u00A0" }) }), _jsx("div", { className: "config-rows config-receivers", children: rows })] }));
};
